module.exports = __webpack_public_path__ + "static/media/shopping-cart-full.42895a2d.svg";